import Stripe from './Stripe.js'

export default {
  [Stripe.vendor]: Stripe,
}
